import PapersNavigation from "./Pagination";

export default PapersNavigation;
